import $ from 'jquery'

export function initialise() {
  $('body').on('submit', 'form[data-ajax-form]', function (event) {
    event.preventDefault()

    var $form = $(event.currentTarget)
    var config = $form.data('ajax-form')

    var formAction = $form.prop('action')

    // post ajax form and update content areas
    $.post(formAction, $form.serialize(), function (response, status, xhr) {
      if (config.redirect) {
        window.location.href = config.redirect
      } else {
        $('<div></div>')
          .append(response)
          .find('[data-ajax-form-target]')
          .each(function () {
            var $el = $(this)
            $('[data-ajax-form-target="' + $el.data('ajax-form-target') + '"]').replaceWith($el)
            $el.trigger('ajax.replace')
          })
      }
    })
  })
}
